import Nullstack from 'nullstack';
export default function IconGitPullRequestClosed({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-git-pull-request-closed",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "6",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M6 8v8"
  }), "   ", Nullstack.element("path", {
    d: "M18 11v5"
  }), "   ", Nullstack.element("path", {
    d: "M16 4l4 4m0 -4l-4 4"
  }), " ");
}